import utils, { CUSTOM_MESSAGES } from 'utils';
import { DropdownTemplate, SkeletonLoader, CustomAccordion, Input, WithLoadingComponent, CustomChip } from 'components';
import { InputFormTepmlate } from 'components/pages/client-management/client-info-edit';
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router';
import { FolderService } from 'services/http';

export const FolderInterventionFilter = () => {

    const history = useHistory();
    const getSearchFolderObject = () => { return JSON.parse(new URLSearchParams(history.location.search).get('folder-search')); }
    const [querySearchFolder, setQuerySearhFolder] = useState(getSearchFolderObject());

    useEffect(() => {
        setQuerySearhFolder(getSearchFolderObject());
    }, [new URLSearchParams(window.location.search).get('folder-search')]);

    const onClearFolderSearch = () => {
        const queryParams = new URLSearchParams(history.location.search);
        queryParams.delete("folder-search");
        history.replace({ search: queryParams.toString() });
    }

    return (
        <div className="folder-filter-container">
            <CustomAccordion
                headerClass="folder-accordion"
                header={
                    <div className={`d-flex ${!querySearchFolder && 'pb-3'}`}>
                        {querySearchFolder ?
                            <>
                                <i className="bi bi-x-circle mt-2" onClick={onClearFolderSearch} />
                                <div>
                                    <SearchItem label={`Client: ${querySearchFolder.clientFirstname ? querySearchFolder.clientFirstname : ``} ${querySearchFolder.clientLastname ? querySearchFolder.clientLastname : ``}`} display={querySearchFolder.clientFirstname || querySearchFolder.clientLastname} />
                                    <SearchItem label={`SourceId: ${querySearchFolder.sourceId}`} display={querySearchFolder.sourceId} />
                                    <SearchItem label={`StatusId: ${querySearchFolder.statusId}`} display={querySearchFolder.statusId} />
                                    <SearchItem label={`Tag: ${querySearchFolder.tagDescription}`} display={querySearchFolder.tagDescription} />
                                    <SearchItem label={`Start date: ${querySearchFolder.startDate}`} display={querySearchFolder.startDate} />
                                    <SearchItem label={`End date: ${querySearchFolder.endDate}`} display={querySearchFolder.endDate} />
                                    <SearchItem label={`Agent: ${querySearchFolder.agent}`} display={querySearchFolder.agent} />
                                    <SearchItem label={`Keyword: ${querySearchFolder.content}`} display={querySearchFolder.content} />
                                    <SearchItem label={`Task Id: ${querySearchFolder.taskId}`} display={querySearchFolder.taskId} />
                                </div>
                            </> :
                            <span className="mt-1">
                                <i className="bi bi-search mx-2" /> Search
                            </span>}
                    </div>}
                content={<FolderFilterCriteriasHoc />} />
        </div>
    );
}

const SearchItem = (props) => {
    return (
        <>
            {
                props.display && <span className="mx-1">
                    <CustomChip label={props.label} />
                </span>
            }
        </>
    )
}

const FolderFilterCriterias = (props) => {

    const history = useHistory();
    const { data: folderRes } = props;
    const querySearchFolder = JSON.parse(new URLSearchParams(window.location.search).get('folder-search'));
    let sourceOptions = folderRes.sources.map((item) => { item['value'] = item.sourceId; return item; });
    let statusOptions = folderRes.statuses.map((item) => { item['value'] = item.statusId; return item; });
    let tagsOptions = folderRes.tags.map((item) => { item['value'] = item.description; return item; });
    let agentsOptions = folderRes.users.map((item) => { let user = {}; user['value'] = item; return user; })

    const [filterItems, setFilterItems] = useState({
        clientFirstname: querySearchFolder ? querySearchFolder.clientFirstname : null,
        clientLastname: querySearchFolder ? querySearchFolder.clientLastname : null,
        sourceId: querySearchFolder ? querySearchFolder.sourceId : null,
        statusId: querySearchFolder ? querySearchFolder.statusId : null,
        tagDescription: querySearchFolder ? querySearchFolder.tagDescription : null,
        startDate: querySearchFolder ? querySearchFolder.startDate : null,
        endDate: querySearchFolder ? querySearchFolder.endDate : null,
        agent: querySearchFolder ? querySearchFolder.agent : null,
        content: querySearchFolder ? querySearchFolder.content : null,
        taskId: querySearchFolder ? querySearchFolder.taskId : null
    });

    useEffect(() => {
        const filterRequest = () => {
            const querySearchFolder = new URLSearchParams(history.location.search);
            querySearchFolder.set("folder-search", JSON.stringify(filterItems));
            history.replace({ search: querySearchFolder.toString() })
        }
        if (filterItems.clientFirstname || filterItems.clientLastname || filterItems.sourceId || filterItems.statusId || filterItems.tagDescription || (filterItems.startDate && filterItems.endDate) || filterItems.agent || filterItems.content || filterItems.taskId) {
            if (filterItems.startDate && filterItems.endDate) {
                if (utils.validateRengeDates(filterItems.startDate, filterItems.endDate)) {
                    filterRequest();
                } else {
                    alert(CUSTOM_MESSAGES.INVALID_RANGE_DATES);
                }
            } else {
                filterRequest();
            }
        }
    }, [filterItems]);

    return (
        <>
            <InputFormTepmlate label="Agent" >
                <DropdownTemplate
                    placeholder="Agent"
                    options={agentsOptions}
                    icon="bi bi-person-circle"
                    selectedItem={filterItems.agent}
                    optionLabel="value"
                    className="sm-dropdown"
                    style={{ width: '100%' }}
                    scrollHeight={200}
                    onItemChange={(e) => { setFilterItems({ ...filterItems, agent: e.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Source" >
                <DropdownTemplate
                    placeholder="Source"
                    options={sourceOptions}
                    icon="bi bi-chat-text"
                    selectedItem={filterItems.sourceId}
                    optionLabel="value"
                    className="sm-dropdown"
                    style={{ width: '100%' }}
                    onItemChange={(e) => { setFilterItems({ ...filterItems, sourceId: e.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Status" >
                <DropdownTemplate
                    placeholder="Status"
                    options={statusOptions}
                    selectedItem={filterItems.statusId}
                    optionLabel="value"
                    icon="bi bi-clock-history"
                    className="sm-dropdown"
                    style={{ width: '100%' }}
                    onItemChange={(e) => { setFilterItems({ ...filterItems, statusId: e.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Tags" >
                <DropdownTemplate
                    placeholder="Tag"
                    options={tagsOptions}
                    selectedItem={filterItems.tagDescription}
                    optionLabel="value"
                    icon="bi bi-tag"
                    className="sm-dropdown"
                    style={{ width: '100%' }}
                    scrollHeight={200}
                    onItemChange={(e) => { setFilterItems({ ...filterItems, tagDescription: e.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Client firstname" >
                <Input
                    placeholder="Firstname"
                    icon="bi bi-person-check"
                    value={filterItems.clientFirstname}
                    onChange={(e) => { setFilterItems({ ...filterItems, clientFirstname: e.target.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Client lastname" >
                <Input
                    placeholder="Lastname"
                    icon="bi bi-person-plus"
                    value={filterItems.clientLastname}
                    onChange={(e) => { setFilterItems({ ...filterItems, clientLastname: e.target.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Start date" >
                <Input
                    placeholder="Start date"
                    icon="bi bi-calendar-minus"
                    value={filterItems.startDate}
                    type="date"
                    onChange={(e) => { setFilterItems({ ...filterItems, startDate: e.target.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="End date" >
                <Input
                    placeholder="End date"
                    icon="bi bi-calendar-check"
                    value={filterItems.endDate}
                    type="date"
                    onChange={(e) => { setFilterItems({ ...filterItems, endDate: e.target.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Keyword" >
                <Input
                    placeholder="Keyword"
                    icon="bi bi-key"
                    value={filterItems.content}
                    onChange={(e) => { setFilterItems({ ...filterItems, content: e.target.value }) }} />
            </InputFormTepmlate>

            <InputFormTepmlate label="Task ID" >
                <Input
                    placeholder="Task Id"
                    icon="bi bi-pin-angle"
                    value={filterItems.taskId}
                    type="number"
                    onChange={(e) => { setFilterItems({ ...filterItems, taskId: e.target.value }) }} />
            </InputFormTepmlate>
        </>
    );
}

//const FolderFilterCriteriasHoc = WithLoadingComponent(FolderFilterCriterias, () => FolderService.getFolderResources(), < SkeletonLoader factor={3} />)()

const FolderFilterCriteriasHoc = () => {
    const Hoc = useMemo(() => WithLoadingComponent(FolderFilterCriterias, () => FolderService.getFolderResources(), <SkeletonLoader rectangle factor={4} />)(), []);
    return <Hoc />
}

